const planConfig = [
    {
        CLIENT_ID : '5448',
        iframeURL : 'https://www.universalhealthfellowship.org/uhs-standard-program-grid/'
    },
    {
        CLIENT_ID : '5449',
        iframeURL : 'https://www.universalhealthfellowship.org/uhs-standard-program-grid/'
    },
    {
        CLIENT_ID : '5514',
        iframeURL : 'https://www.universalhealthfellowship.org/uhs-standard-program-grid/'
    },
    {
        CLIENT_ID : '5515',
        iframeURL : 'https://www.universalhealthfellowship.org/uhs-standard-program-grid/'
    },
    {
        CLIENT_ID : '4350',
        iframeURL : 'https://www.universalhealthfellowship.org/uhs-afa-program-grid/'
    },
    {
        CLIENT_ID : '4429',
        iframeURL : 'https://www.universalhealthfellowship.org/uhs-standard-246-program-grid/'
    },
    {
        CLIENT_ID : '4428',
        iframeURL : 'https://www.universalhealthfellowship.org/uhs-standard-246-program-grid/'
    },
    {
        CLIENT_ID : '5446',
        iframeURL : 'https://www.universalhealthfellowship.org/uhs-standard-246-program-grid/'
    },
    {
        CLIENT_ID : '5447',
        iframeURL : 'https://www.universalhealthfellowship.org/uhs-standard-246-program-grid/'
    },
    {
        CLIENT_ID : '5450',
        iframeURL : 'https://www.universalhealthfellowship.org/uhs-standard-246-program-grid/'
    },
    {
        CLIENT_ID : '5503',
        iframeURL : 'https://www.universalhealthfellowship.org/uhs-standard-program-grid/'
    },
    {
        CLIENT_ID : '6548',
        iframeURL : 'https://www.universalhealthfellowship.org/uhs-healthy-life-program-grid/'
    },
    {
        CLIENT_ID : '4364',
        iframeURL : 'https://www.universalhealthfellowship.org/uhs-standard-program-grid/'
    },
    {
        CLIENT_ID : '5540',
        iframeURL : 'https://www.universalhealthfellowship.org/uhs-healthy-life-program-grid/'
    },
]

export default planConfig;